export default __webpack_public_path__ + "static/landingCityA-a0b255d125b9c8e52cc74acd43881a24.png";